import { Component } from "react";
import styles from "./rich-text-expandable-text.module.less";
import ExpandContent from "components/block-elements/expand-content/expand-content";
import RichTextRenderer from "components/block-elements/rich-text-renderer/rich-text-renderer";
import { extract } from "@parksandresorts/core";

class RichTextExpandableText extends Component {
  constructor(props) {
    super(props);
    this.expandableRichText = extract(props, "expandTextBody");
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <ExpandContent>
          <RichTextRenderer richTextData={this.expandableRichText} />
        </ExpandContent>
      </div>
    );
  }
}

export default RichTextExpandableText;
